import { useSelector } from 'react-redux';
import { useGetRosterForIncident } from './useRoster';
import { useActualIncidentId } from '../../components/IAP/hooks/commonHooks';

/**
 * Hook to check if the current user has approval authority in the incident
 * roster
 *
 * @returns Boolean indicating if current user has approval authority
 */
export const useCurrentUserApprovalAuthority = (): boolean => {
  const userGuid = useSelector(
    (state: { app: { user: { user_guid: string } } }) =>
      state.app.user?.user_guid
  );

  const incidentId = useActualIncidentId();
  const { data: rosterData } = useGetRosterForIncident(incidentId);

  if (!userGuid || !rosterData) {
    return false;
  }

  const currentUserData = rosterData.find(
    (member) => member.userId === userGuid
  );

  return currentUserData?.approvalAuthority || false;
};
